export default {
  picks: {
    imageImport: {
      dropzoneBody: "Importez une photo et nous récupérerons les picks pour vous.",
      dropzoneCta: "Cliquez ici ou glissez-déposez pour téléverser",
      preparingResults: "Préparation des résultats",
      adding: "Ajout...",
      importedPicks: "Picks importés",
    },
    actions: {
      findTrends: "Trouver des tendances",
    },
    labels: {
      sgpPricingUnavailable: "Cote SGP non disponible",
    },
    plusPromo: {
      description: "Obtenez accès à des jeux avancés et à des analyses plus poussées",
    },
  },
};
